module.exports = __webpack_public_path__ + "img/PHONE.85ce73dc.svg";